import {
    bottomSidebarItems,
    sidebarItems,
    unauthorizedSidebarItems
} from '../configs/sidebar-items/sidebar-items.config';
import { footerLinks } from '../configs/footer-items/footer-items.config';
import { TranslateService } from '@ngx-translate/core';
import { FooterLink, SidebarItem } from '@siemens/component-lib';
import { TranslatedApplicationFrameItem } from './shared/interfaces/TranslatedApplicationFrameItem';

export class AppComponentOperations {
    public static getInitializedApplicationFrameTranslations(
        translateService: TranslateService
    ): TranslatedApplicationFrameItem {
        const translatedSidebarItems: SidebarItem[] = sidebarItems.map(sidebarItem => ({
            ...sidebarItem,
            name: translateService.instant(sidebarItem.name),
            tooltip: translateService.instant(sidebarItem.tooltip),
            ariaLabel: translateService.instant(sidebarItem.ariaLabel as string)
        }));

        const translatedFooterItems: FooterLink[] = footerLinks.map(footerLink => ({
            ...footerLink,
            text: translateService.instant(footerLink.text)
        }));

        const translatedBottomSidebarItems: SidebarItem[] = bottomSidebarItems.map(bottomSidebarItem => ({
            ...bottomSidebarItem,
            name: translateService.instant(bottomSidebarItem.name),
            tooltip: translateService.instant(bottomSidebarItem.tooltip),
            ariaLabel: translateService.instant(bottomSidebarItem.ariaLabel as string)
        }));

        const translatedUnauthorizedSidebarItems: SidebarItem[] = unauthorizedSidebarItems.map(
            unauthorizedSidebarItem => ({
                ...unauthorizedSidebarItem,
                name: translateService.instant(unauthorizedSidebarItem.name),
                tooltip: translateService.instant(unauthorizedSidebarItem.tooltip),
                ariaLabel: translateService.instant(unauthorizedSidebarItem.ariaLabel as string)
            })
        );
        return {
            sidebarItems: translatedSidebarItems,
            footerLinks: translatedFooterItems,
            bottomSidebarItems: translatedBottomSidebarItems,
            unauthorizedSidebarItems: translatedUnauthorizedSidebarItems
        };
    }
}
